// thumbs
import thumbStudio from "@images/Lookbook/thumbnails/studio-to-sea.webp"
import thumbIsland from "@images/Lookbook/thumbnails/island-life.webp"
import thumbCaramel from "@images/Lookbook/thumbnails/caramel-eyelet.webp"
import thumbBbxBratz from "@images/Lookbook/thumbnails/bb-x-bratz.webp"

// lookbook banners
import bannerSummerEscapez from '@images/Lookbook/banners/bratz-banner.webp'
import mobileBannerSummerEscapez from '@images/Lookbook/banners/bratz-banner-mobile.webp'
import bannerCaramel from '@images/Lookbook/banners/caramel-banner.webp'
import mobileBannerCaramel from '@images/Lookbook/banners/caramel-banner-mobile.webp'
import bannerIslandLife from '@images/Lookbook/banners/island-life-banner.webp'
import mobileBannerIslandLife from '@images/Lookbook/banners/island-life-banner-mobile.webp'
import bannerStudioToSea from '@images/Lookbook/banners/studio-to-sea-banner.webp'
import mobileBannerStudioToSea from '@images/Lookbook/banners/studio-to-sea-banner-mobile.webp'

export const lookbooks = [
	{
		title: "Summer Escapez",
		subTitle: "Bratz® x Blackbough",
		buttonLabel: "Summer Escapez",
		image: thumbBbxBratz,
		bannerImage: bannerSummerEscapez,
		mobileBannerImage: mobileBannerSummerEscapez,
		link: "/lookbooks/bratz",
	},
	{
		title: "Caramel Eyelet",
		subTitle: "A delectable summer treat",
		buttonLabel: "Caramel Eyelet",
		image: thumbCaramel,
		bannerImage: bannerCaramel,
		mobileBannerImage: mobileBannerCaramel,
		link: "/lookbooks/caramel-eyelet",
	},
	{
		title: "Island Life",
		subTitle: "The Ashley & Kelly Edit",
		buttonLabel: "Island Life",
		image: thumbIsland,
		bannerImage: bannerIslandLife,
		mobileBannerImage: mobileBannerIslandLife,
		link: "/lookbooks/the-ashley-kelly-island-life",
	},
	{
		title: "Studio to Sea",
		subTitle: "Swim that moves with you, wherever your day goes.",
		buttonLabel: "Studio to Sea",
		image: thumbStudio,
		bannerImage: bannerStudioToSea,
		mobileBannerImage: mobileBannerStudioToSea,
		link: "/lookbooks/studio-to-sea",
	},

]
